import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ButtonsModule } from "@progress/kendo-angular-buttons";
import { ToolBarModule, ToolBarToolComponent } from '@progress/kendo-angular-toolbar';
import { GridSearchToolComponent } from './flows/grid-search-tool.component';
import { ToolbarItemComponent } from './flows/toolbar-item.component';
import { GridModule } from '@progress/kendo-angular-grid';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { ChartsModule } from '@progress/kendo-angular-charts';
import { TimePickerModule } from '@progress/kendo-angular-dateinputs';
import { MultiSelectModule } from '@progress/kendo-angular-dropdowns';
import { LabelModule } from '@progress/kendo-angular-label';
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { InputsModule, CheckBoxModule, NumericTextBoxModule } from "@progress/kendo-angular-inputs"
import { IntlModule } from "@progress/kendo-angular-intl";
import { DropDownsModule } from "@progress/kendo-angular-dropdowns"
import { DialogModule } from "@progress/kendo-angular-dialog"

@NgModule({
  declarations: [
    GridSearchToolComponent,
    ToolbarItemComponent
  ],
  imports: [
    CommonModule,
    ButtonsModule,
    ToolBarModule,
    LabelModule,
    GridModule,
    LayoutModule,
    ChartsModule,
    InputsModule,
    CheckBoxModule,
    NumericTextBoxModule,
    TimePickerModule,
    DropDownsModule,
    MultiSelectModule,
    FormsModule, 
    ReactiveFormsModule,
    DialogModule
  ],
  exports: [
    GridSearchToolComponent,
    ToolbarItemComponent,
    ButtonsModule,
    ToolBarModule,
    LabelModule,
    GridModule,
    LayoutModule,
    ChartsModule,
    InputsModule,
    CheckBoxModule,
    NumericTextBoxModule,
    IntlModule,
    TimePickerModule,
    DropDownsModule,
    MultiSelectModule,
    FormsModule, 
    ReactiveFormsModule,
    DialogModule,

  ]
})
export class SharedModule { }
